var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdeate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 55",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8,
    cy: 33.5,
    fill: "#0b9fc4",
    r: 21.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1,
    cy: 15.1,
    fill: "#00d563",
    r: 14.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.3 27c2.5 1.8 5.5 2.9 8.8 2.9 8.2 0 14.8-6.6 14.8-14.8s-.1-2-.3-2.9c-.9-.1-1.9-.2-2.8-.2-9.6 0-17.7 6.3-20.5 15z",
    fill: "#12c6a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeate);
export default __webpack_public_path__ + "static/media/ideate.d7c1ce56dd72f5d4eacab462fdb02b46.svg";
export { ForwardRef as ReactComponent };